<template>
    <div>
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            USUÁRIO -
                            <b-badge variant="warning">{{ operacao }}</b-badge>
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <detalhe titulo="Nome" :size="size1">
                            {{ usuario.nome }}
                        </detalhe>
                        <detalhe titulo="Login" :size="size1">
                            {{ usuario.login }}
                        </detalhe>
                        <detalhe titulo="Email" :size="size1">
                            {{ usuario.email }}
                        </detalhe>
                        <detalhe titulo="Status" :size="size1">
                            <app-status
                                :status="
                                    usuario.statusDescr
                                        ? usuario.statusDescr
                                        : ''
                                "
                            ></app-status>
                        </detalhe>
                        <detalhe titulo="Última Atualização" :size="size1">
                            {{
                                usuario.dataAtualizacao
                                    ? $moment(usuario.dataAtualizacao).format(
                                          'DD/MM/YYYY HH:mm'
                                      )
                                    : ''
                            }}
                        </detalhe>
                    </b-card-body>
                    <b-card-footer>
                        <app-usuario-ativar-desativar
                            :usuario="usuario"
                            @obterUsuario="obterUsuario()"
                        ></app-usuario-ativar-desativar>
                        <app-usuario-resetar-senha 
                            :usuario="usuario"
                        ></app-usuario-resetar-senha>
                        <app-usuario-atualizar
                            :usuario="usuario"
                        ></app-usuario-atualizar>
                        <b-button variant="danger" @click.stop="voltar()">
                            <span>
                                <i class="fa fa-history mr-1"></i> Voltar
                            </span>
                        </b-button>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-tabs pills card vertical>
                        <b-tab title="Perfis de Acesso" active class="pb-0">
                            <app-usuario-perfis-acesso
                                v-if="$temAcessoView('CTRLACS-USR-06-01')"
                                :usuario="usuario"
                                @obterUsuario="obterUsuario()"
                            ></app-usuario-perfis-acesso>
                        </b-tab>
                        <b-tab title="Contratos" active class="pb-0" v-if="$temAcessoView('CTRLACS-USR-07-01')">
                            <app-usuario-contrato
                                :usuario="usuario"
                                @obterUsuario="obterUsuario()"
                            ></app-usuario-contrato>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import UsuariosServicos from './UsuariosServicos'
import UsuarioPerfisAcesso from './UsuarioPerfisAcesso'
import UsuarioResetarSenha from './UsuarioResetarSenha'
import UsuarioAtivarDesativar from './UsuarioAtivarDesativar'
import UsuarioAtualizar from './UsuarioAtualizar'
import UsuarioContratos from './UsuarioContratos'

export default {
    data() {
        return {
            usuario: {},
            size: '50',
            size1: '115'
        }
    },

    methods: {
        voltar() {
            this.$router.push({ name: 'Usuarios' })
        },

        obterUsuario() {
            this.$store.dispatch('addRequest')
            UsuariosServicos.obterPorId(this.$route.params.usuarioId).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.usuario = response.data
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        transferirParaAtualizacao() {
            this.$router.push({
                name: 'Usuarios_Atualizar',
                params: { usuarioId: this.$route.params.usuarioId }
            })
        },

        
    },

    computed: {
        mostrarBtnAtualizar() {
            return this.$temAcessoView('CTRLACS-USR-03')
        }
    },

    created() {
        this.operacao = 'DETALHAR'
            this.obterUsuario()
    },

    components: {
        AppUsuarioPerfisAcesso: UsuarioPerfisAcesso,
        AppUsuarioResetarSenha: UsuarioResetarSenha,
        AppUsuarioAtivarDesativar: UsuarioAtivarDesativar,
        AppUsuarioAtualizar: UsuarioAtualizar,
        AppUsuarioContrato: UsuarioContratos
    }
}
</script>
